import { lazyLoad } from 'utils/loadable';

export const QuestionFormPage = lazyLoad(
  () => import('./index'),
  module => module.QuestionFormPage,
);
